module.exports = __webpack_public_path__ + "img/404.64ce32b2.jpg";